import type { ApprovalDecision } from "~/components/tool-ui/approval-card";
import type { HitlToolProps } from "./hitlTools";
import type { ToolCallEntry } from "./useTurns";

// Derives the ApprovalCard interaction props shared by every approval-style HITL
// card (`ask_for_approval`, `public_dataset_trigger_run`): the
// prior decision as `choice`, plus approve/deny handlers that resume the paused
// run via `onAnswer`. The handlers are undefined in read-only views (no
// `onAnswer`), which disables the buttons; a rejected `onAnswer` re-enables them
// so retry just works.
//
// `choice` isn't a literal match on `entry.result` — approving a tool with a
// real handler runs it, so `entry.result` becomes its return value, not the
// literal "approved". Only an exact "denied" means denied (pydantic-ai's
// `ToolDenied` never runs the tool); any other defined result means approved.
export function approvalWiring(entry: ToolCallEntry, onAnswer: HitlToolProps["onAnswer"]) {
  const choice: ApprovalDecision | undefined =
    entry.result === undefined ? undefined : entry.result === "denied" ? "denied" : "approved";
  return {
    choice,
    onConfirm: onAnswer ? () => onAnswer(entry.id, "approved") : undefined,
    onCancel: onAnswer ? () => onAnswer(entry.id, "denied") : undefined,
  };
}
